//sticky side bar
import StickySidebar from "sticky-sidebar";

jQuery(document).ready(function ($) {
  // career details page  sticky sidebar
  if ($(".sidebar").length) {
    let width = $(window).width(); // Get the current window width
    if (width >= 768) {
      let sidebar = new StickySidebar("#sidebar", {
        containerSelector: "#main-content",
        innerWrapperSelector: ".sidebar__inner",
        topSpacing: 177,
        bottomSpacing: 30,
        resizeSensor: true,
      });
    }
  }

  //scroll to div

  if ($(".single-career").length) {
    let headerHeight = $("#site-header").outerHeight();
    $('a[href*="#"]')
      .not('a[href="#"]')
      .not('a[href="#0"]')
      .on("click", function (e) {
        e.preventDefault(); // prevent hard jump, the default behavior
        let target = $(this).attr("href"); // Set the target as variable

        // perform animated scrolling by getting top-position of target-element and set it as scroll target
        $("html, body").animate(
          {
            scrollTop: $(target).offset().top + headerHeight,
          },
          0,
          function () {
            // Initial animation complete, now add 20px more scroll
            $("html, body").animate(
              {
                scrollTop: $(target).offset().top + headerHeight - 250,
              },
              0
            ); // Adjust the duration as needed
            location.hash = target;
          }
        );

        return false;
      });
  }
  // on scroll  add active class to  active sidebar text
  $(window)
    .scroll(function () {
      let scrollDistance = $(window).scrollTop();
      $(window).scroll(function () {
        let windscroll = $(window).scrollTop();
        if (windscroll >= 100) {
          // Assign active class to nav links while scolling
          $(".page-section").each(function (i) {
            if ($(this).position().top - 500 <= scrollDistance) {
              $("#sticky-sidebar  ul li a.active").removeClass("active");
              $("#sticky-sidebar  ul li a").eq(i).addClass("active");
            }
          });
        }
      });
    })
    .scroll();
});
